import { render, staticRenderFns } from "./TextareaDefault.vue?vue&type=template&id=4c850fa8"
import script from "./TextareaDefault.vue?vue&type=script&lang=js"
export * from "./TextareaDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports